import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert } from 'react-bootstrap';
import { GoogleLogin } from '@react-oauth/google';
import './AdminLogin.css';

const AdminLogin = ({ onLogin }) => {
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // This function starts when we successfully login with google
  const handleGoogleSuccess = async (credentialResponse) => {
    setError('');
    
    try {
      // Sending credential token that google gave our backend

      //const response = await fetch('http://localhost:5000/api/google-login', {
      const response = await fetch('/api/google-login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: credentialResponse.credential }),
      });

      const data = await response.json();

      if (data.success) {
        // If the backend says that the mail is @level9c.com we get JWT token
        localStorage.setItem('adminToken', data.token);
        onLogin(true);
        navigate('/admin-dashboard');
      } else {
        // If the backend refuses (wrong domain)
        setError(data.message || 'Access denied. Authorized personnel only.');
      }
    } catch (err) {
      setError('Server error during Google login. Please try again.');
    }
  };

  return (
    <div className="admin-login-page">
      <Container className="d-flex justify-content-center align-items-center h-100">
        <div className="login-card text-center">
          <div className="mb-4">
            <h2 className="login-title">HDPMG <span className="blue-text">ADMIN</span></h2>
            <p className="text-muted">Level 9 Security Portal</p>
          </div>

          {error && <Alert variant="danger">{error}</Alert>}

          <div className="d-flex justify-content-center mt-4">
            {/* Google button*/}
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={() => setError('Google Login Failed')}
              useOneTap 
              theme="filled_blue"
              shape="pill"
            />
          </div>

          <p className="mt-4 small text-muted">
            Authorized level9c accounts only
          </p>
        </div>
      </Container>
    </div>
  );
};

export default AdminLogin;